<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import LoginForm from './LoginForm.svelte';
	import RegisterForm from './RegisterForm.svelte';
	import { filterIsVisible } from './shared/filter';
	import { activeItem, items, loginOverlayIsVisible } from './stores/header';

	const dispatch = createEventDispatcher();

	$: if ($loginOverlayIsVisible) {
		$filterIsVisible = false;
	}

	const close = () => {
		dispatch('close');
	};

	const handleKeydown = (event) => {
		if (event.key === 'Escape') {
			close();
		}
	};
</script>

<svelte:window on:keydown={handleKeydown} />

<div
	class="py-5 px-5 md:px-6 bg-beige bg-opacity-smidge backdrop-filter backdrop-blur-sm fixed z-30 top-0 w-full border-b max-h-screen overflow-auto overscroll-contain"
>
	<div class="flex ">
		<div class="flex space-x-4">
			{#each items as item}
				<button
					type="button"
					aria-pressed={$activeItem === item}
					on:click={() => {
						$activeItem = item;
					}}>{item}</button
				>
			{/each}
		</div>

		<div class="ml-auto">
			<button
				type="button"
				class="order-last p-3 -m-3"
				on:click={() => {
					dispatch('close');
				}}
			>
				<span class="sr-only">Schließen</span>
				<svg
					viewBox="0 0 18 18"
					width="18"
					height="18"
					aria-hidden="true"
					focusable="false"
				>
					<path
						d="M1 1L17 17 M17 1 L1 17"
						stroke="currentColor"
						stroke-linecap="square"
					/>
				</svg>
			</button>
		</div>
	</div>

	<div class="mt-4">
		{#if $activeItem === 'Login'}
			<LoginForm on:close={close} />
		{/if}
		{#if $activeItem === 'Registrieren'}
			<RegisterForm />
		{/if}
	</div>
</div>

<style lang="postcss">
	button[aria-pressed='false'] {
		color: theme('colors.gray.45');
	}
</style>
